/*
 * @Description:
 * @Date: 2025-07-10 15:02:10
 * @LastEditors: function
 * @LastEditTime: 2025-10-23 16:57:49
 * @FilePath: \protal-web\src\main.js
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./config/vuex/stroe.js";
import "animate.css";
import { getApiStatus } from "@/api/home";

Vue.config.productionTip = false;

Vue.prototype.$goRouter = (path, query) => {
  router.push({ path: path, query });
};

Vue.prototype.$goPath = (path, isLocal = true) => {
  let token = localStorage.getItem("token");
  const basePath = process.env.VUE_APP_BASE_URL;
  if (isLocal) {
    if (token) {
      location.href = basePath + path + "?token=" + token;
    } else {
      const local = location.origin;
      location.href = `${basePath}/login?redirectUrl=${local}`;
    }
  } else {
    location.href = `${basePath}/login?redirectUrl=${basePath}${path}`;
  }
};

if (!window.sessionStorage.getItem("api_status")) {
  getApiStatus({})
    .then((res) => {
      window.sessionStorage.setItem("api_status", res.data);
      new Vue({
        router,
        store,
        render: (h) => h(App),
      }).$mount("#app");
    })
    .catch((error) => {
      window.sessionStorage.setItem("api_status", false);
      new Vue({
        router,
        store,
        render: (h) => h(App),
      }).$mount("#app");
    });
} else {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}
